module.exports = __webpack_public_path__ + "img/07.acd959e5.png";